import Box from '@mui/material/Box'
import { StyledCircularProgress } from 'Components/CircularProgress/StyledCircularProgress'

export const SectionCircleLoader = () => (
  <Box sx={{ display: 'flex' }}>
    <StyledCircularProgress />
  </Box>
)
